<template>
  <v-container>
    <v-card class="mb-6 batch-disabled-card" color="grey lighten-4">
      <div id="batch-disabled-message">
        <h1>Batch Processing Not Enabled</h1>
        <p class="icon"><v-icon color="orange">mdi-alert</v-icon></p>
        <p class="grey--text">Batch processing is not enabled on this instance. <br/> Please contact SLLT support to enable batch processing.<br/><br/></p>
        <base-input-primary-button label="Go to home" @click="backToHome"/>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import BaseInputPrimaryButton from '@/base/input/BaseInputPrimaryButton'

export default {
  name: 'BatchNotEnabled',
  components: { BaseInputPrimaryButton },

  methods: {
    backToHome () {
      this.$router.push({ name: 'Home' })
    }
  }
}

</script>

<style scoped>

#batch-disabled-message {
  text-align: center;
  padding: 50px;
}

#batch-disabled-message h1 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
}

#batch-disabled-message p {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
}

#batch-disabled-message .icon {
  font-size: 50px;
  margin: 20px 0;
}

</style>
